import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Disciplined Investment",
    text: "We assess each opportunity against sound commercial fundamentals, with a focus on protecting capital and achieving sustainable returns. Investing our own funds allows us to make decisions independently, without pressure from external fund timelines.",
    testid: "approach-step-capital",
  },
  {
    num: "02",
    title: "Practical Partnership",
    text: "We work closely with management teams, contributing experience and operational support. Where our businesses complement one another, we seek opportunities to share expertise, improve efficiency and support growth.",
    testid: "approach-step-synergy",
  },
  {
    num: "03",
    title: "Balanced Risk",
    text: "We manage risk through careful investment selection, prudent financial structures and diversification across businesses, property and sectors. We consider both the merits of each investment and its contribution to the resilience of the wider portfolio.",
    testid: "approach-step-risk",
  },
  {
    num: "04",
    title: "Long-Term Ownership",
    text: "We invest with a long-term perspective, giving businesses the time and support to develop. We back capable management teams, respect the communities in which we operate and focus on building value over time.",
    testid: "approach-step-stewardship",
  },
];

const fade = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export default function Approach() {
  return (
    <section id="approach" data-testid="approach-section" className="py-20 lg:py-28 bg-[#E8F0F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          variants={fade}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="max-w-2xl"
        >
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#12344E] leading-tight">
            Our Investment Approach
          </h2>
          <p className="mt-5 text-base text-[#4A6076] leading-relaxed">
            We invest our own capital with patience and purpose. Four
            principles guide how we assess opportunities, support our
            businesses and build lasting value.
          </p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={s.testid}
              variants={fade}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1 }}
              className="bg-white rounded-lg border border-[#D5E2EC] border-l-4 border-l-[#1F6191] p-8 lg:p-10 shadow-[0_4px_18px_rgba(18,52,78,0.05)]"
            >
              <span className="font-mono text-sm tracking-[0.3em] text-[#1F6191]/70">
                {s.num}
              </span>
              <h3 className="text-xl lg:text-2xl font-bold text-[#12344E] mt-3">{s.title}</h3>
              <p className="text-sm text-[#4A6076] leading-relaxed mt-3 max-w-md">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
